import { ref } from 'vue'
import { createInjectionState } from '@vueuse/shared'
import type { DirectusSchema } from '#root/types/content'

type TrainerPersonsInitialData = DirectusSchema['persons'] | undefined

const [useProvideTrainerPersonsStore, useTrainerPersonsStore] =
  createInjectionState((initialData: TrainerPersonsInitialData) => {
    const items = ref(initialData)

    return {
      items
    }
  })

function useTrainerPersonsStoreOrThrow() {
  const trainerPersonsStore = useTrainerPersonsStore()
  if (trainerPersonsStore == null)
    throw new Error(
      'Please call `useProvideTrainerPersonsStore` on the appropriate parent component'
    )
  return trainerPersonsStore
}

export { useProvideTrainerPersonsStore, useTrainerPersonsStoreOrThrow }
